<template>
  <section class="mb-6">
    <h2
      v-if="title"
      class="mb-3 flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-slate-100"
    >
      <span v-if="icon" class="text-2xl">{{ icon }}</span>
      {{ title }}
    </h2>
    <KekkleCard padding="none" class="overflow-hidden">
      <slot />
    </KekkleCard>
  </section>
</template>

<script setup lang="ts">
import KekkleCard from "./KekkleCard.vue";

type Props = {
  title?: string;
  icon?: string;
};

defineProps<Props>();
</script>
